'use client';
const requestMethods = [
    'get',
    'post',
    'put',
    'patch',
    'head',
    'delete'
];
const responseTypes = {
    json: 'application/json',
    text: 'text/*',
    formData: 'multipart/form-data',
    arrayBuffer: '*/*',
    blob: '*/*'
};
// Максимальное значение 32-битного целочисленного типа -- совместимость с node
const maxSafeTimeout = 2147483647;

export { maxSafeTimeout, requestMethods, responseTypes };
//# sourceMappingURL=constants.js.map
